import { render, staticRenderFns } from "./CommissionRate.vue?vue&type=template&id=a354b70e&scoped=true&"
import script from "./CommissionRate.vue?vue&type=script&lang=ts&"
export * from "./CommissionRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a354b70e",
  null
  
)

export default component.exports